export function formatMultilineText(value?: string | null): string {
  const text = value?.replaceAll('|', '\n').trim() ?? '';

  return text || '-';
}

export const textOrDash = (value?: string | number | null): string => {
  const text = value == null ? '' : String(value).trim();

  return text || '-';
};
